import type { Configuration } from "@azure/msal-browser";

/**
 * IMPORTANT (security):
 * - Do NOT put "Client Secret" values in the frontend (Vite env).
 * - SPA apps must use Authorization Code Flow with PKCE (handled by MSAL).
 * - Any client secret should live ONLY on your backend.
 */

const tenantId = import.meta.env.VITE_MICROSOFT_TENANT_ID as string | undefined;
const clientId = import.meta.env.VITE_MICROSOFT_CLIENT_ID as string | undefined;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "",
    authority: tenantId
      ? `https://login.microsoftonline.com/${tenantId}`
      : "https://login.microsoftonline.com/common",
    redirectUri:
      (import.meta.env.VITE_MICROSOFT_REDIRECT_URI as string | undefined) ??
      `${window.location.origin}/login`,
    postLogoutRedirectUri:
      (import.meta.env.VITE_MICROSOFT_POST_LOGOUT_REDIRECT_URI as
        | string
        | undefined) ?? `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
  system: {
    loggerOptions: {
      // keep quiet in prod; enable if you need to debug SSO
      loggerCallback: () => undefined,
      piiLoggingEnabled: false,
      logLevel: 0,
    },
  },
};

/**
 * Default scopes. We request `User.Read` to get a usable access token.
 * If your tenant doesn't allow Graph consent, you can remove `User.Read`
 * and rely on `idToken` only for backend exchange.
 */
export const microsoftLoginRequest = {
  scopes: ["User.Read"],
};
